import Immutable from "immutable";
import keyConverter from "services/key-converter";

export const ActivityRecord = Immutable.Record({
  id: null,
  activityType: null,
  batchIds: null,
  batchSeries: null,
  clientId: null,
  created: null,
  dataAfter: null,
  dataBefore: null,
  resourcePk: null,
  resourceType: null,
  responseId: null,
  undid: false,
  userId: null
});

export const activities = (state = Immutable.List([]), action) => {
  let nextState = state;

  switch (action.type) {
    case "GET_ACITVITIES_SUCCESS":
      nextState = nextState.clear();
      action.response.data.activitys.forEach((activity) => {
        const newActivity = new ActivityRecord(keyConverter(activity));
        nextState = nextState.push(newActivity);
      });

      return nextState;
    case "GET_MORE_ACITVITIES_SUCCESS":
      action.response.data.activitys.forEach((activity) => {
        const newActivity = new ActivityRecord(keyConverter(activity));
        nextState = nextState.push(newActivity);
      });

      return nextState;

    case "UNDO_ACTIVITY_SUCCESS": {
      const activityIndex = nextState.indexOf(action.activity);
      const updatedActivity = action.activity.set("undid", action.response.data.undone);

      return nextState.set(activityIndex, updatedActivity);
    }

    default:
      return nextState;
  }
};
